import * as React from "react";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";


class DataSync extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timerHandle: null
        };
        this.StartTimer = this.StartTimer.bind(this);
        this.TimerTick = this.TimerTick.bind(this);
        this.EndTimer = this.EndTimer.bind(this);
    }

    componentDidMount() {
        this.StartTimer();
    }

    componentDidUpdate(prevState, prevProps) {
        this.StartTimer();
    }

    componentWillUnmount() {
        this.EndTimer();
    }

    StartTimer() {
        var { timerHandle } = this.state;
        if (!timerHandle) {
            timerHandle = window.setInterval(this.TimerTick, window.serverData.data.syncIntervalMilliseconds);
            this.setState({ timerHandle: timerHandle });
        }
    }

    EndTimer() {
        const { timerHandle } = this.state;
        if (timerHandle) {
            window.clearInterval(timerHandle);
            this.setState({ timerHandle: null });
        }
    }

    TimerTick() {
        const { bffToken, RefreshData, serverData } = this.props;
        if (bffToken && RefreshData && serverData.data && serverData.data.enableSyncCall) {
            RefreshData();
        }
    }

    render() {
        return (
            <React.Fragment />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        bffToken: state.domain.idt,
        serverData: state.session.serverData,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RefreshData: () => {
            dispatch({ type: types.SYNC_ROOMS });
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSync);


